import React from 'react';
import { useNavigate } from 'react-router-dom';
import './App.css';
import BackButton from './BackButton';

function ChoosePhototype() {
  const navigate = useNavigate();

  const handleSelect = (type) => {
    if (type === 'dealership') {
      navigate('/quick-start-guide');
    } else if (type === 'license') {
      navigate('/frame-selection');
    }
  };

  const handleSupportClick = () => {
    navigate('/support');
  };

  return (
    <div className="ChoosePhototype">
      <h1 className="ChoosePhototype-title">
        What content would you like to customize for your dealership?
      </h1>
      <div className="ChoosePhototype-options">
        <div
          className="ChoosePhototype-option"
          onClick={() => handleSelect('dealership')}
        >
          <div className="ChoosePhototype-image-placeholder">
            <img src="/components/icons/Send_Photos.png" alt="Custom Dealer Backgrounds" style={{ width: '100%', height: '100%' }} />
          </div>
          <span className="ChoosePhototype-label">
            Custom Dealer<br />Backgrounds
          </span>
        </div>
        <div
          className="ChoosePhototype-option"
          onClick={() => handleSelect('license')}
        >
          <div className="ChoosePhototype-image-placeholder">
            <img src="/components/icons/Dealer_plate_icon.png" alt="Custom License Plates and Frames" style={{ width: '100%', height: '100%' }} />
          </div>
          <span className="ChoosePhototype-label">
            Custom License<br />Plates/Frames
          </span>
        </div>
      </div>
      <div className="ChoosePhototype-support">
        Questions?{' '}
        <span className="support-link" onClick={handleSupportClick}>Click here</span>
        {' '}to reach out to our support team directly.
      </div>
      <BackButton />
    </div>
  );
}

export default ChoosePhototype;
